import { Tabs } from 'antd';
import { useQueryParamsAsKeyValuePair } from 'hooks/useQueryParams';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router';
import { ITransactionType } from 'types/services';
import { getNewQueryString } from 'utils';

import { getActiveAppointmentTabs } from './helpers';

const { TabPane } = Tabs;

const ActiveAppointmentTabs: React.FC<{ transactionTypesData?: ITransactionType[] }> = ({
  transactionTypesData = [],
}) => {
  const history = useHistory();
  const { location } = history;
  const queryObject = useQueryParamsAsKeyValuePair();
  const tab = queryObject?.tab;
  const activeAppointmentTabs = useMemo(() => getActiveAppointmentTabs(), []);

  return (
    <Tabs
      className='w-full h-full-ant-tab'
      tabBarStyle={{ paddingLeft: 16, marginBottom: 0 }}
      defaultActiveKey={tab || '0'}
      onChange={(key) => {
        const queryString = getNewQueryString(location.search, { tab: key });
        history.push({
          pathname: location.pathname,
          search: queryString,
        });
      }}>
      {activeAppointmentTabs.map((t, index) => (
        <TabPane tab={t.title} key={index} className='overflow-auto'>
          <t.component transactionTypesData={transactionTypesData} />
        </TabPane>
      ))}
    </Tabs>
  );
};

export default React.memo(ActiveAppointmentTabs);
